import PropTypes from "prop-types";

function formatPct(value) {
    if (value === null || value === undefined) return "—";
    return `${(value * 100).toFixed(2)}%`;
}

function formatSize(value) {
    if (value === null || value === undefined) return "—";
    return value;
}

export default function LiveExposureOverview({ exposure = [], className = "" }) {
    const rows = Array.isArray(exposure) ? exposure : [];
    return (
        <div className={`rounded-xl border border-gray-800 bg-gray-900/70 p-4 ${className}`} data-testid="live-exposure-overview">
            <div className="flex items-center justify-between mb-3">
                <div>
                    <p className="text-[0.7rem] uppercase tracking-wide text-gray-400">Live Exposure Overview</p>
                    <h3 className="text-base font-semibold text-white">Per-coin sizing caps</h3>
                </div>
                <span className="text-xs text-gray-400">Read-only</span>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full text-left text-sm text-gray-200">
                    <thead className="text-xs uppercase text-gray-400">
                        <tr>
                            <th className="py-2 pr-4">Symbol</th>
                            <th className="py-2 pr-4">Binance</th>
                            <th className="py-2 pr-4">Base %</th>
                            <th className="py-2 pr-4">Max %</th>
                            <th className="py-2 pr-4">Min trade size</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.symbol} className="border-t border-gray-800">
                                <td className="py-2 pr-4 font-semibold">{row.symbol}</td>
                                <td className="py-2 pr-4">
                                    <span
                                        className={`px-2 py-0.5 rounded text-xs ${
                                            row.binance_enabled ? "bg-emerald-900/50 text-emerald-200" : "bg-gray-800 text-gray-300"
                                        }`}
                                    >
                                        {row.binance_enabled ? "Enabled" : "Disabled"}
                                    </span>
                                </td>
                                <td className="py-2 pr-4">{formatPct(row.live_sizing?.base_pct)}</td>
                                <td className="py-2 pr-4">{formatPct(row.live_sizing?.max_pct)}</td>
                                <td className="py-2 pr-4">{formatSize(row.live_sizing?.min_trade_size)}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && (
                            <tr>
                                <td className="py-3 text-sm text-gray-400" colSpan={5}>
                                    No live sizing data available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

LiveExposureOverview.propTypes = {
    exposure: PropTypes.arrayOf(PropTypes.shape({
        symbol: PropTypes.string,
        binance_enabled: PropTypes.bool,
        live_sizing: PropTypes.object,
    })),
    className: PropTypes.string,
};
